import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';

const Navigation = () => {
    return (
        <div class="navbar-fixed">
        <nav className={'light-green lighten-1'} role="navigation">
            <div className={'row'}>     
            <a href='/' class="brand-logo" style = {{margin: 2}}><img width="60" class="icon hide-on-med-and-down" src={require('../Resources/Images/logo_round.png')} /></a>       
                <ul className={'right'}>
                    <li class="col s4 m4 l4">
                        <Link to={'/'}>
                            <a className={'white-text'}>Home</a>
                        </Link>
                    </li>
                    <li class="col s4 m4 l4">
                        <Link to={'/terms'}>
                            <a className={'white-text'}>Terms</a>
                        </Link>
                    </li>
                    <li class="col s4 m4 l4">
                        <Link to={'/policy'}>
                            <a className={'white-text'}>Privacy</a>
                        </Link>
                    </li>                   
                </ul>
            </div>
        </nav>
        </div>
    );
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Component/Navigation.js